


const NoInternet = () => {
    const handleTryAgain = () => {
        window.location.reload();
    };

    return (
        <div
            className="d-flex justify-content-center align-items-center vh-100"
            style={{
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                overflow: 'hidden',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                zIndex: 9999,
            }}
        >
            {/* Animated background shapes for depth */}
            <div
                style={{
                    position: 'absolute',
                    width: '300px',
                    height: '300px',
                    background: 'rgba(0, 71, 171, 0.1)',
                    borderRadius: '50%',
                    top: '-50px',
                    right: '-50px',
                    filter: 'blur(80px)',
                }}
            ></div>
            <div
                style={{
                    position: 'absolute',
                    width: '250px',
                    height: '250px',
                    background: 'rgba(255, 77, 77, 0.08)',
                    borderRadius: '50%',
                    bottom: '10%',
                    left: '-50px',
                    filter: 'blur(60px)',
                }}
            ></div>

            <div
                className="text-center p-5"
                style={{
                    background: 'rgba(255, 255, 255, 0.7)',
                    backdropFilter: 'blur(15px)',
                    WebkitBackdropFilter: 'blur(15px)',
                    borderRadius: '24px',
                    border: '1px solid rgba(255, 255, 255, 0.4)',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.07)',
                    maxWidth: '450px',
                    width: '90%',
                    animation: 'fadeInUp 0.8s ease-out',
                }}
            >
                <div className="mb-4" style={{ position: 'relative' }}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100"
                        height="100"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                            color: '#0047ab',
                            filter: 'drop-shadow(0 4px 6px rgba(0, 71, 171, 0.2))',
                        }}
                    >
                        <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                        <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                        <line x1="12" y1="20" x2="12.01" y2="20" strokeWidth="3" />
                        <line
                            x1="2"
                            y1="2"
                            x2="22"
                            y2="22"
                            stroke="#ff4d4d"
                            strokeWidth="2"
                            style={{
                                strokeDasharray: '30',
                                strokeDashoffset: '0',
                                animation: 'drawSlash 2s infinite ease-in-out',
                            }}
                        />
                    </svg>
                </div>

                <h2
                    className="fw-bold mb-3"
                    style={{ color: '#2d3748', letterSpacing: '-0.5px' }}
                >
                    Connection Lost
                </h2>
                <p
                    className="text-secondary mb-4 px-3"
                    style={{ fontSize: '1.05rem', lineHeight: '1.6' }}
                >
                    It seems you're currently offline. Please check your internet
                    connection and try again.
                </p>

                <button
                    onClick={handleTryAgain}
                    className="btn btn-primary px-5 py-3 rounded-pill fw-semibold shadow-sm transition-all"
                    style={{
                        background: '#0047ab',
                        border: 'none',
                        fontSize: '1rem',
                        transition: 'transform 0.2s, boxShadow 0.2s',
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow =
                            '0 6px 15px rgba(0, 71, 171, 0.3)';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    <i className="bi bi-arrow-clockwise me-2"></i>
                    Try Again
                </button>

                <div className="mt-4 pt-2">
                    <small className="text-muted d-flex align-items-center justify-content-center">
                        <span
                            style={{
                                width: '8px',
                                height: '8px',
                                background: '#ff4d4d',
                                borderRadius: '50%',
                                display: 'inline-block',
                                marginRight: '8px',
                                animation: 'pulse 1.5s infinite',
                            }}
                        ></span>
                        Waiting for connection...
                    </small>
                </div>
            </div>

            <style>{`
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes pulse {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.2); opacity: 0.5; }
                    100% { transform: scale(1); opacity: 1; }
                }
                @keyframes drawSlash {
                    0% { stroke-dashoffset: 0; }
                    50% { stroke-dashoffset: 60; }
                    100% { stroke-dashoffset: 0; }
                }
                .transition-all {
                    transition: all 0.3s ease;
                }
            `}</style>
        </div>
    );
};

export default NoInternet;